export default __webpack_public_path__ + "static/media/85.585e3088.jpg";